import {
  APPLIANCE_PAGINATED_FETCH_STARTED,
  APPLIANCE_PAGINATED_FETCH_SUCCEEDED,
  APPLIANCE_PAGINATED_FETCH_FAILED,
  APPLIANCE_PAGINATED_CHANGE_PAGE,
  APPLIANCE_PAGINATED_CHANGE_ITEMS_PER_PAGE,
  APPLIANCE_PAGINATED_CLEAR,
  APPLIANCE_PAGINATED_SET_FILTER
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  appliances: [],
  error: null,
  page: 1,
  itemsPerPage: 12,
  pages: 0,
  filter: null,
  filterBy: ['label', 'uid'],
  order: 'asc',
  orderBy: ['label']
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APPLIANCE_PAGINATED_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case APPLIANCE_PAGINATED_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        appliances: action.payload,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case APPLIANCE_PAGINATED_FETCH_FAILED:
      return {
        ...state,
        status: statuses.failed,
        appliances: [],
        devices: [],
        error: action.error
      };
    case APPLIANCE_PAGINATED_SET_FILTER:
      return { ...state, filter: action.payload };
    case APPLIANCE_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case APPLIANCE_PAGINATED_CHANGE_ITEMS_PER_PAGE:
      return { ...state, itemsPerPage: action.payload };
    case APPLIANCE_PAGINATED_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
